export const DEFAULT_DRIVER_AVATAR_URL = "/images/drivers/default-driver.svg";
export const BLANK_DRIVER_AVATAR_DATA_URL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

function normalizeUrl(url?: string | null) {
  const trimmed = url?.trim();
  return trimmed ? trimmed : null;
}

export function getDriverInitials(name: string) {
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 3)
    .toUpperCase();
}

export function getDriverAvatarSources({
  slug,
  profileImageUrl,
  includeDefault = true,
  preferLocal = false,
}: {
  slug?: string | null;
  profileImageUrl?: string | null;
  includeDefault?: boolean;
  /** When true, local headshot avatars are tried before the DB profileImageUrl.
   *  Use for small circular avatars where full-body images crop poorly. */
  preferLocal?: boolean;
}) {
  const dbUrl = normalizeUrl(profileImageUrl);
  const localPaths = [
    slug ? `/images/avatars-webp/${slug}.webp` : null,
    slug ? `/images/avatars/${slug}.webp` : null,
    slug ? `/images/avatars/${slug}.png` : null,
    slug ? `/images/drivers/${slug}.jpg` : null,
  ];

  const candidates = preferLocal
    ? [...localPaths, dbUrl, includeDefault ? DEFAULT_DRIVER_AVATAR_URL : null]
    : [dbUrl, ...localPaths, includeDefault ? DEFAULT_DRIVER_AVATAR_URL : null];

  return Array.from(new Set(
    candidates.filter((c): c is string => Boolean(c))
  ));
}
